<script>
	import { fade, fly } from 'svelte/transition';

	let visible = true
	const vanish = ()=>{
		setTimeout(()=>{
			visible = false
		}, 400)
	}
	window.addEventListener("load", vanish);
</script>
{#if visible}
<div class="preload" out:fade="{{duration: 800}}" opacity=1>
	<img src="../images/poviard_preload.svg" alt="" transition:fly="{{ y: -200, duration: 600 }}">
</div>
{/if}

<style>
.preload{
	background-color: var(--blue-dark);
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 15;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>